query RatingMetricByHome(
  $from: LocalDate
  $to: LocalDate
  $homeIds: [UUID!]
  $regionIds: [UUID!]
  $filters: [RatingFilter!]
  $homeFilters: RatingHomeFiltersInput
  $sort: [RatingSort!]
  $pagination: PaginationInput
) {
  _: rating {
    _: ratingMetricByHome(
      from: $from
      to: $to
      homeIds: $homeIds
      regionIds: $regionIds
      filters: $filters
      homeFilters: $homeFilters
      sort: $sort
      pagination: $pagination
    ) {
      total
      pages
      results {
        home {
          id
          name
        }
        region {
          name
        }
        airbnb {
          avgOverall
          avgAccuracy
          avgCheckIn
          avgCommunication
          avgCleanliness
          avgLocation
          avgValue
          conversion {
            numberOfReviews
            numberOfBookings
            conversionRate
          }
        }
        vrbo {
          avgOverall
          avgCheckIn
          avgCommunication
          avgLocation
          avgOnlineListing
          avgRoomCleanliness
          conversion {
            numberOfReviews
            numberOfBookings
            conversionRate
          }
        }
        nps {
          promoters
          detractors
          conversion {
            numberOfReviews
            numberOfBookings
            conversionRate
          }
          score
        }
      }
    }
  }
}
